import { jsonStringToObject } from './common';

export function getAuthorizedUsersAndSuppliersForFeatureFlag({
  featureFlagEmailBasedValue = JSON.stringify([]),
  featureFlagSupplierBasedValue = JSON.stringify([]),
  userEmail,
  supplierId,
}) {
  const authorizedEmails = jsonStringToObject(featureFlagEmailBasedValue, []);
  const authorizedSupplierIds = jsonStringToObject(featureFlagSupplierBasedValue, []);

  const isAllowedByEmail = userEmail && Array.isArray(authorizedEmails) && authorizedEmails.includes(userEmail);
  const isAllowedBySupplierId =
    supplierId && Array.isArray(authorizedSupplierIds) && authorizedSupplierIds.includes(Number(supplierId));

  return {
    isAllowedByEmail,
    isAllowedBySupplierId,
  };
}

export function isFeatureFlagEnabledForUserOrSupplier(featureFlagConfig) {
  return featureFlagConfig.isAllowedByEmail || featureFlagConfig.isAllowedBySupplierId;
}
